<template>
    <div>
        <Spin :spinning="loading">
            <Tooltip title="点赞">
                <div class="like-container" @click="like">
                    <slot name="liked" v-if="isLike"></slot>
                    <slot name="unLiked" v-else></slot>
                </div>
            </Tooltip>
        </Spin>
    </div>
</template>

<script setup lang="ts">
import {Spin, Tooltip} from "ant-design-vue";
import {ref, watch} from "vue";
import http from "@/utils/http";

const props = defineProps<{
    likeUrl: string,
    dataUrl?: string,
    data?: any,
    isLike?: boolean,
}>()

const loading = ref(false)


const isLike = ref(props.isLike)

watch(() => props.isLike, () => {
    if (props.isLike === isLike.value) {
        return
    }

    isLike.value = props.isLike
})

const like = async (e: Event) => {
    e.stopPropagation()
    e.preventDefault()
    loading.value = true
    try {
        await http.post(props.likeUrl)
        isLike.value = !isLike.value
    } catch (e) {
    }
    loading.value = false

}

</script>

<style scoped lang="less">
.like-container {
    cursor: pointer;
    display: flex;
    align-items: center;
}
</style>
